<template>
  <div class="px-4 ml-6 pt-3 layout-row layout-wrap" :style="{'background': compColor.lxExpansion.background}">

    <!-- Kopfdaten -->

    <div class="flex-gt-sm-100 flex-100 mt-2">
      <div class="flex-100 px-3 py-1 mb-3 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.REPORTER_PERSONAL_CONTRIBUTION') }}</span>
      </div>

      <melder path="headerData"
              v-model="model.headerData"
              :formKey="model.formType"
              :additionalItemsList="additionalItemsList"
              :validationRef="validationRef"
              :isImport="true"
              :disableManuallyValidate="true"
      ></melder>
    </div>

    <!-- Grunddaten -->

    <div class="flex-100 px-3 py-1 my-6 mx-2"
         :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
         style="border-radius: 4px;">
      <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.BASE_PROGRESS_SUB_LINE') }}</span>
    </div>


    <div class="flex-100 px-2 mb-1">

      <!-- OP Intension -->

      <validation-provider tag="div"
                           :name="path + '.additionalFields.operation.op_intention'"
                           :ref="path + '.additionalFields.operation.op_intention'"
                           rules="required"
                           v-slot="{ errors }">

        <fake-input-frame :label="$t('FORMS_DIVERSE.BASE_OPERATION_OP_INTENSION') + ' *'"
                          :errors="errors.length > 0">
          <div class="layout-column px-4 py-2 flex">
            <v-radio-group :dense="denseFields" v-model="model.additionalFields.operation.op_intention" :error-messages="errors[0]" hide-details class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio v-for="(value, key) in opIntentionTypes"
                       :label="value.text"
                       :title="value.title"
                       :value="key"
                       :key="key"
                       :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                       class="mb-1"
                       :dark="compColor.isInDarkMode">
              </v-radio>
            </v-radio-group>
          </div>
        </fake-input-frame>
        <span class="error--text" style="line-height:12px;font-size:12px;margin-top: 3px;margin-left:10px;">{{ errors[0] }}</span>
      </validation-provider>
    </div>

    <!--  Operationen  -->

    <div class="flex-100 px-2">
      <fake-input-frame :label="$t('FORMS_DIVERSE.BASE_OPERATION_OPS') + ' *'">
        <div class="layout layout-column px-2 pb-2">

          <div class="flex-gt-sm-100 flex-100 px-2">
            <!-- hidden input field to show error, if array of ops is empty -->
            <validation-provider tag="div"
                                 :name="path + '.additionalFields.operation.op_ops'"
                                 :ref="path + '.additionalFields.operation.op_ops'"
                                 rules="required|at_least_one_op_is_selected"
                                 v-slot="{ errors }">
              <lx-alert-box v-show="errors[0]" color="red" class="my-2">
                {{ $t('ERROR_EMPTY_OPS_ARRAY') }}
              </lx-alert-box>

              <v-text-field
                v-model="model.additionalFields.operation.op_ops"
                v-show="false"
                :error-messages="errors[0]"
              ></v-text-field>
            </validation-provider>
          </div>

          <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center pa-1 mt-2">
            <lx-btn icon="add_circle"
                    :color="compColor.primeColor"
                    :iconColor="'white'"
                    :label="$t('FORMS_DIVERSE.BASE_OPERATION_ADD_NEW_OP')"
                    :tooltip="$t('FORMS_DIVERSE.BASE_OPERATION_ADD_NEW_OP')"
                    iconSize="21"
                    :width="'auto'"
                    :height="35"
                    @click="addItem('additionalFields.operation.op_ops', {})"
            ></lx-btn>
          </div>

          <div :key="index" v-for="(item, index) in model.additionalFields.operation.op_ops"
               class="layout-row pa-0 ma-1"
               :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
               style="border-radius:4px;"
               :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

            <div class="layout-row layout-wrap flex-gt-sm-100 px-4 pt-4 pb-2">

              <!-- OP Code via Auto-Complete -->

              <div class="flex-gt-sm-20 flex-100 pr-2">
                <validation-provider tag="div"
                                     :name="path + '.additionalFields.operation.op_ops.' + index + '.code'"
                                     :ref="path + '.additionalFields.operation.op_ops.' + index + '.code'"
                                     rules="required"
                                     v-slot="{ errors }">
                  <lx-autocomplete
                    :label="$t('FORMS_DIVERSE.BASE_OPERATION_OP_CODE') + ' *'"
                    v-model="item.code"
                    :error="errors[0]"
                    @search-method="getDataForAutocomplete"
                    @input="setOps"
                    :index="index"
                    :hide-details="!errors || errors.length <= 0"
                    :dense="denseFields"
                    :results="resultSearchModel">
                    <template v-slot="slotProps">
                      <div class="layout-row">
                        <div style="width: 100px;border-radius: 4px;" class="mr-2 px-2 white lighten-2 layout-column layout-align-center-center">
                          <h3>
                            <lx-text-highlight :text="slotProps.lineItem.code" :search-string="slotProps.searchText" :color="compColor.prime"></lx-text-highlight>
                          </h3>
                        </div>
                        <div class="flex">
                          <span class="body-2">
                            <lx-text-highlight :text="slotProps.lineItem.description" :search-string="slotProps.searchText" :color="compColor.prime"></lx-text-highlight>
                          </span>
                        </div>
                      </div>
                    </template>
                  </lx-autocomplete>
                </validation-provider>
              </div>

              <!-- Morphologie ICDO-Version -->

              <div class="flex-gt-sm-25 flex-100 px-2">
                <validation-provider tag="div"
                                     :name="path + '.additionalFields.operation.op_ops.' + index + '.version'"
                                     :ref="path + '.additionalFields.operation.op_ops.' + index + '.version'"
                                     rules="required"
                                     v-slot="{ errors }">
                  <v-select
                    :color="compColor.primeColor"
                    :label="$t('FORMS_DIVERSE.BASE_OPERATION_OP_VERSION') + ' *'"
                    v-model="item.version"
                    :items="opOpsVersionTypes"
                    outlined
                    class="mb-0"
                    @change="resetOpCode(index)"
                    :persistent-hint="true"
                    :hint="$t('FORMS_DIVERSE.CODE_VERSION_HINT')"
                    :dense="denseFields"
                    :error-messages="errors[0]"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :dark="compColor.isInDarkMode">
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item v-on="on"
                                   :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                        <v-list-item-content class="py-0">
                          <label style="cursor:pointer;"
                                 :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                                 class="lighten-4 text--darken-2">{{ item.text }}</label>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </validation-provider>
              </div>

              <!-- Beschreibungstext zur OP  -->

              <div class="flex-gt-sm-55 flex-100 pl-2">
                <validation-provider tag="div"
                                     :name="path + '.additionalFields.operation.op_ops.' + index + '.description'"
                                     :ref="path + '.additionalFields.operation.op_ops.' + index + '.description'"
                                     rules=""
                                     v-slot="{ errors }">
                  <v-text-field
                    :label="$t('FORMS_DIVERSE.BASE_OPERATION_OP_DESCRIPTION')"
                    :color="compColor.primeColor"
                    :dark="compColor.isInDarkMode"
                    v-model="item.description"
                    disabled
                    :dense="denseFields"
                    outlined
                    :hide-details="!errors || errors.length <= 0"
                    :error-messages="errors[0]"
                    class="ma-0"
                  ></v-text-field>
                </validation-provider>
              </div>
            </div>

            <div class="layout-column layout-align-center-center px-3"
                 :class="{'grey lighten-2': !compColor.isInDarkMode}"
                 :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
              <lx-btn @click="deleteItem('additionalFields.operation.op_ops', index)"
                      :color="compColor.primeColor"
                      :iconColor="'white'"
                      iconSize="21"
                      :disabled="model.additionalFields.operation.op_ops && model.additionalFields.operation.op_ops.length === 1"
                      :width="35"
                      :height="35"
                      icon="delete_forever"></lx-btn>
            </div>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!--  Operateure  -->

    <div class="flex-100 px-2 my-3">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_SURGEON_HEADER')">
        <div class="layout layout-column px-2 py-2">
          <operateure path="additionalFields.operation.operateure"
                      class="mb-3"
                      v-model="model.additionalFields.operation.operateure"
                      :disableManuallyValidate="true"
                      v-bind="{addItem, deleteItem}"
          ></operateure>
        </div>
      </fake-input-frame>
    </div>

    <!--  Residualstatus   -->

    <div class="flex-100 px-2 my-3">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_RESIDUAL_STATUS_HEADER')">
        <div class="layout layout-column px-2 py-2">
          <residualstatus path="additionalFields.operation.residualstatus"
                          :isDisabled="isFormDisabled()"
                          :isRequired="true"
                          v-model="model.additionalFields.operation.residualstatus"
                          class="layout-row layout-wrap flex-gt-sm-100 flex-100"></residualstatus>
        </div>
      </fake-input-frame>
    </div>

    <!--  OP-Komplikationen  -->

    <div class="flex-100 px-2 my-3">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_OP_COMPLICATIONS_HEADER') + ' *'">
        <div class="layout layout-column px-2 py-2">
          <op-komplikationen path="additionalFields.operation.op_komplikation"
                             :isDisabled="isFormDisabled()"
                             :isRequired="true"
                             :addNewItem="addItem"
                             :validationRef="validationRef"
                             v-model="model.additionalFields.operation.op_komplikation"
                             class="layout-row layout-wrap flex-gt-sm-100 flex-100"></op-komplikationen>
        </div>
      </fake-input-frame>
    </div>

    <!--  Histologie  -->

    <div class="flex-100 px-2 my-3">
      <fake-input-frame :label="$t('FORMS_DIVERSE.HISTOLOGY_HEADER')">
        <div class="layout layout-column px-2 py-2">
          <histologie path="additionalFields.operation.histologie"
                      :isDisabled="isFormDisabled()"
                      :isRequired="false"
                      v-model="model.additionalFields.operation.histologie"
                      class="layout-row layout-wrap flex-gt-sm-100 flex-100"></histologie>
        </div>
      </fake-input-frame>
    </div>

    <!--  ANMERKUNG  -->

    <div class="flex-gt-sm-100 flex-100 mt-3">
      <div class="flex-100 px-3 py-1 mb-6 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.ANNOTATION_HEADER') }}</span>
      </div>

      <anmerkung path="additionalFields.operation.anmerkung"
                 :isDisabled="isFormDisabled()"
                 v-model="model.additionalFields.operation.anmerkung"
                 class="layout-wrap flex-gt-sm-100 flex-100"></anmerkung>
    </div>
  </div>
</template>

<script>
import metaData from '../../../components/documentation/shared/formsMetaData'
import utils from '../../../common/utils'

import LxAutocomplete from '../../../components/lx_auto_complete/LxAutocomplete'
import Residualstatus from '../../../components/documentation/shared/Residualstatus'
import Operateure from '../../../components/documentation/shared/Operateure'
import Histologie from '../../../components/documentation/shared/Histologie'
import opKomplikationen from '../../../components/documentation/shared/OpKomplikationen'
import Melder from '../../../components/documentation/shared/Melder'
import Anmerkung from '../../../components/documentation/shared/Anmerkung.vue'

export default {
  name: "Operation",
  mixins: [metaData, utils],
  components: {
    Melder,
    Operateure,
    Residualstatus,
    Histologie,
    opKomplikationen,
    LxAutocomplete,
    Anmerkung
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        additionalFields: {
          operation: {}
        }
      })
    },
    path: {
      type: String
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    additionalItemsList: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      model: {
        additionalFields: {
          operation: {}
        }
      },
      opIntentionTypes: [],
      opOpsVersionTypes: [],
      resultSearchModel: {},
      OP_OPS_VersionTypes: null,
    }
  },
  created () {
    this.opIntentionTypes = this.formsMetaData.OP_IntentionTypes
    this.opOpsVersionTypes = this.filterVersions('ops')
  },
  methods: {
    /**
     * Delete ops-code and description after changing version
     *
     * @param index The index of morphology-element
     */
    resetOpCode (index) {
      this.$delete(this.model.additionalFields.operation.op_ops[index], 'code')
      this.$delete(this.model.additionalFields.operation.op_ops[index], 'description')
    },

    /**
     * Get list of ops codes via regex in auto-complete
     *
     * @param data The search string
     * @param index The index of selected item
     */
    getDataForAutocomplete (data, index) {
      if (data && this.model.additionalFields.operation.op_ops[index].code && data !== this.model.additionalFields.operation.op_ops[index].code) {
        this.$set(this.model.additionalFields.operation.op_ops[index], 'description', undefined)
      }

      // clear string from special characters to provide errors
      data = this.clearStringForRegexSearch(data)

      let config = {
        opts: {
          limit: 40
        },
        query: {
          searchValue: data
        }
      }

      // if icd-10 version is set, send it to backend
      const foundVersion = this.opOpsVersionTypes.find(elem => elem.value === this.model.additionalFields.operation.op_ops[index].version)

      if (foundVersion?.value) {
        config.query.version = foundVersion.value
      }

      this.$http.get('/ops?config=' + JSON.stringify(config))
        .then(res => {
          this.resultSearchModel = {
            result: res.data.items,
            index: index,
            count: res.data.count || 0,
            version: res.data.version
          }
        })
        .catch(this.NotifyError)
    },

    /**
     * Set ops value via list form auto complete
     *
     * @param data The selected ops from list
     * @param index The index of element in ops-array
     */
    setOps (data, index) {
      if (data && data.code) {
        this.$set(this.model.additionalFields.operation.op_ops[index], 'code', data.code)
        this.$set(this.model.additionalFields.operation.op_ops[index], 'description', data.description)

        if (!this.model.additionalFields.operation.op_ops[index].version) {
          const version = this.resultSearchModel.version || this.formsMetaData.OPS_Version
          this.$set(this.model.additionalFields.operation.op_ops[index], 'version', version)
        }
      } else {
        if (!this.model.additionalFields.operation.op_ops[index].code || typeof data === 'string' || (this.validationRef.errors && this.validationRef.errors[this.path + '.additionalFields.operation.op_ops.' + index + '.code'] && this.validationRef.errors[this.path + '.additionalFields.operation.op_ops.' + index + '.code'].length > 0)) {
          // nextTick is necessary to trigger watcher in autocomplete on the right way
          this.$nextTick(() => {
            // delete input of ops-code, if not selected from result list
            if (typeof data === 'string') this.$set(this.model.additionalFields.operation.op_ops[index], 'code', null)
          })

          this.$set(this.model.additionalFields.operation.op_ops[index], 'description', undefined)
        }
      }
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue && oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue

          if (!this.model.additionalFields) {
            this.$set(this.model, 'additionalFields', { operation: {} })
          }
        }
      },
      immediate: true
    },
    'model.additionalFields.operation.op_ops': {
      deep: true,
      handler: function (newValue) {
        if (newValue) {
          this.$refs[this.path + '.additionalFields.operation.op_ops'].validate()
        }
      }
    }
  }
}
</script>
